import React, { Component } from "react";
import ReactDOM from "react-dom";
import PriceBase from "./PriceBase";
import * as actions from "../actions/creators/cartAction";

export default class ItemBase extends PriceBase {
	constructor(props) {
		super(props);
		this.state = {};
	}

	addToCart(e, items) {
		this.props.dispatch(actions.fetchAddToCart(items));
	}

	removeItem(e, item) {
		this.props.dispatch(actions.fetchRemoveFromCart(item));
	}

	modifyItem(e, id, prevAmount, amount) {
		const data = {};
		data.Id = id;
		data.PrevAmount = prevAmount;
		data.Amount = amount;
		this.props.dispatch(actions.fetchModifyCart(data));
	}
}
